import { FaCaretDown } from '@meronex/icons/fa';
import { Box, ButtonProps, Heading, Spinner } from '@apia/theme';
import { useAppSelector } from '../../../../../hooks/hooks';
import store, { TRootState } from '../../../../../store';
import { getSpecificParent } from '../../../../../utils/dom';
import Stage from './Stage';

export interface IButton extends ButtonProps {
  isSelectedSelector: (state: TRootState) => boolean;
  label: string;
  title: string;
  action: () => unknown;
  isDisabled?: boolean;
  value?: string;
}

export interface IStage {
  name: string;
  buttons?: IButton[];
}

const SchedulerMini = () => {
  const data = useAppSelector((global) => global.schedulerSlice.data);

  const stagesLength = useAppSelector(
    (global) => global.schedulerSlice?.stageData?.length,
  );

  return (
    <Box
      {...window.getVariant('layout.execution.form.fields.scheduler')}
      className="schedulerMini"
      onKeyDown={(ev) => {
        const stage = store.getState().schedulerSlice?.stageData;
        if (ev.key.toLowerCase() === 'arrowleft') {
          const stageName = getSpecificParent(
            ev.target as HTMLElement,
            (current) => current.classList.contains('stage'),
          )?.dataset.name as string;
          const stageIndex = stage.findIndex(
            (current) => current.name === stageName,
          );
          if (stageIndex <= 0) return;

          const nextStage = stage[stageIndex - 1]?.name;
          const firstButton =
            document.querySelector<HTMLElement>(
              `[data-name="${nextStage}"] .selected`,
            ) ||
            document.querySelector<HTMLElement>(
              `[data-name="${nextStage}"] button:not(:disabled)`,
            );
          if (firstButton) firstButton.focus();
        }
        if (ev.key.toLowerCase() === 'arrowright') {
          const stageName = getSpecificParent(
            ev.target as HTMLElement,
            (current) => current.classList.contains('stage'),
          )?.dataset.name as string;
          const stageIndex = stage.findIndex(
            (current) => current.name === stageName,
          );
          if (stageIndex >= stage.length - 1) return;

          const nextStage = stage[stageIndex + 1]?.name;
          const firstButton =
            document.querySelector<HTMLElement>(
              `[data-name="${nextStage}"] .selected`,
            ) ||
            document.querySelector<HTMLElement>(
              `[data-name="${nextStage}"] button:not(:disabled)`,
            );
          if (firstButton) firstButton.focus();
        }
      }}
    >
      {data?.weekNotConfigured && (
        <Heading as="h1">{window.LBL_SCHED_WEEK_NOT_CONFIGURED}</Heading>
      )}
      {!data?.weekNotConfigured && data?.tskSchDay && (
        <>
          <Stage stageIndex={0} />
          {stagesLength >= 2 && (
            <FaCaretDown className="schedulerMini_faCaretDown" />
          )}
          <Stage stageIndex={1} />
          {stagesLength >= 3 && (
            <FaCaretDown className="schedulerMini_faCaretDown" />
          )}
          <Stage stageIndex={2} />
        </>
      )}
      {!data?.weekNotConfigured && !data?.tskSchDay && (
        <Box className="box_spinner" title={window.WAIT_A_SECOND}>
          <Spinner />
        </Box>
      )}
    </Box>
  );
};

export default SchedulerMini;
